export const getResultPoolRequestIds = state => state.persistStore.resultPoolRequestIds;